import React, {  } from "react";


import { observer } from "mobx-react";

import { BottomsheetDropdown } from "components";

const CriticarePlus = ({ form, data }) => {

  return (
    <form>
      <div className=''>
        {/* <div className='px-2 py-2 py-md-2 my-3 mb-md-4'> */}
        <div className="mx-0 my-4">
          {/* <Col md={6} className='col-12 mt-3'> */}
          {/* <div className='mb-2 font-size-12 font-weight-light total-premium-container-heading'>{form.$("policy-term").label}</div> */}
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey='label'
            bottomsheetTitle={form.$("policy-term").label}
            menuList={form.$("policy-term").extra.optionList}
            value={form.$("policy-term").value}
            onSelect={form.$("policy-term").onChange}
          />
          {/* </Col> */}
        </div>
        <div className="mx-0 my-4">
          {/* <Col md={6} className='col-12 mt-3'> */}
          {/* <p className='mb-2 font-size-12 font-weight-light total-premium-container-heading'>{form.$("premium-paying-term").label}</p> */}
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey='label'
            bottomsheetTitle={form.$("premium-paying-term").label}
            menuList={form.$("premium-paying-term").extra.optionList}
            value={form.$("premium-paying-term").value}
            onSelect={form.$("premium-paying-term").onChange}
            disabled={form.$("premium-paying-term").disabled}
          />
          {/* </Col> */}
        </div>
      </div>
    </form >
  );
};
export default observer(CriticarePlus);
